<template>
  <div class="box">
    <div
      class="line"
      ref="lineComp"
    ></div>
  </div>
</template>

<script>
// <g-line size="1"></g-line>  
export default {
  name: "GLine",
  props: {
    size: {
      type: [String, Number],
      default: "10",
    },
    color: {
      type: String,
      default: '',
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {
    if (this.size) {
      this.$refs.lineComp.style.height = parseFloat(this.size) + 'px';
    }
    if (this.color) {
      this.$refs.lineComp.style.background = this.color;
    }
  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
.line {
  height: 10px;
}
</style>
